import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronWhiteLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Icon / chevron-left" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Icon-/-chevron-left",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("polyline", {
				id: "Path",
				stroke: "#fff",
				strokeWidth: 2,
				transform: "translate(12.000000, 12.500000) rotate(-90.000000) translate(-12.000000, -12.500000) ",
				points: "19 16 12 9 5 16"
			})
		})
	]
});
export default SvgChevronWhiteLeft;
